'use strict';

/**
 * Adapter: Humanizer for moment
 *
 * NOTE: When making changes to this file you must create an ES5 version prior to release.
 *
 * @see https://github.com/EvanHahn/HumanizeDuration.js
 *
 * @version 12.4.0 #756 MLIBJS-121 Add validation to export HumanizeDurationMomentAdapter for ES6 usage
 *          7.10.0 #522 Add time conversion functionality
 *
 * @author Dallas Vogels <dvogels@webduct.com>
 * @author Ryan Sweeney <rsweeney@webduct.com>
 * @author Erik Orozco <eorozco@intersog.com>
 *
 * @copyright (c) 2017-2020 Build Centrix
 */
export default class HumanizeDurationMomentAdapter {

    /**
     * Constructor
     *
     * @since 7.10.0
     *
     * @param {humanizeDuration} library
     */
    constructor(library) {

        this.library = library;

    }

    /**
     * Humanize Duration
     *
     * @since 7.10.0
     *
     * @param {Number} input milliseconds
     * @param {Array|String} outputUnits e.g. ['y', 'M', 'w', 'd', 'h', 'm', 's', 'ms'], 'm'
     * @param {Boolean} round default false
     *
     * @returns {String}
     */
    humanizeDuration(input, outputUnits, round = false) {

        if (typeof outputUnits === 'string') {
            outputUnits = [outputUnits];
        }

        // convert any moment month notation (M) to HumanizeDuration month notation (mo)
        for (let counter = 0; counter < outputUnits.length; counter++) {
            if (outputUnits[counter] === 'M') {
                outputUnits[counter] = 'mo';
            }
        }

        let settings = {
            units: outputUnits,
            round: round
        };

        return this.library(input, settings);
    }

}

// CommonJS: this must be after the class declaration
if (typeof module !== 'undefined' && module.exports) {
    module.exports = HumanizeDurationMomentAdapter;
}

// EOF